<script lang="ts">
    import {onMount} from "svelte";
    import {AuthStore} from "../../store/AuthStore";


    onMount(() => {
    });

    $: authStoreAuthStatus = AuthStore.authStatus;


</script>
<div class="footer-view">
    <div class="content">
        <div>
            開発・運用: 第3ｽﾀｼﾞｵ 田路大輔
        </div>
        <div class="small-link-area">
            {#if $authStoreAuthStatus === AuthStore.AuthStatusType.authorized}
                <a href="/api/auth/logout">
                    ログアウト
                </a>
            {/if}
        </div>

    </div>

</div>
<style lang="scss">
    .footer-view {
        margin-top: 256px;
        background-color: var(--color1);
        color: var(--color3);
        padding-top: 32px;
        padding-bottom: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        > .content {
            text-align: center;

            .small-link-area {
                font-size: 12px;

                display: flex;
                align-items: center;
                justify-content: center;
                gap: 12px;

                > a {
                    margin-top: 14px;
                    opacity: 0.5;

                    &:hover {
                        opacity: 1;
                    }
                }
            }

        }


    }
</style>